import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { EventTrackerNavigationReasons } from 'src/app/shared/constants';

@Component({
    selector: 'app-page-card',
    imports: [
        // Angular
        CommonModule,
        RouterLink,
        // Angular Material
        MatCardModule,
        MatIconModule,
        // Own
    ],
    templateUrl: './page-card.component.html',
    styleUrl: './page-card.component.scss'
})
export class PageCardComponent {
    protected EventTrackerNavigationReasons = EventTrackerNavigationReasons;

    @Input({ required: true })
    title!: string;

    @Input({ required: true })
    content!: string;

    @Input({ required: true })
    routerPath: string | undefined;

    @Input()
    cardClass?: string;

    @Input()
    headerClass?: string;

    @Input()
    titleClass?: string;

    @Input()
    contentClass?: string;

    @Input()
    iconName?: string;

    @Input()
    iconClass?: string;

    constructor() {}
}
